import { DocumentoAllegato } from './documento-allegato';
import { Legale } from './legale';
import { TariffaLegaleIncaricato } from './tariffa';
import { Categoria } from './tipologiche/categoria';

export class LegaleIncaricato {
  id: string;
  categoriaLegaleIncaricato: Categoria;
  legale: Legale;
  principale: boolean;
  revocato: boolean;
  dataInizioIncarico: number;
  compensoPattuito: number;
  dataCessazioneIncarico: number;
  dataAssociazione: number = +new Date();
  dataRevoca: number;
  note: string;
  documenti: DocumentoAllegato[];
  tariffeRevisionate?: TariffaLegaleIncaricato[];
}
